(function() {
    $(document).ready(function() {
        let product = get_the_right_product();
        if (!product || !product.product) {
            return ;
        }

        let count_down_timer = null;
        show_daily_deal(product);
    });

    /* -------------------------------separator------------------------------------ */
    
    function get_the_right_product() {
        if (!daily_deal_products?.show) {
            return null;
        }
      
        let now = set_now_time();
        const { list, start_time } = daily_deal_products;
        let this_round = null;
        let next_round = null;
        for (let i in list) {
            const start_time_str = `${this_year}-${i} ${start_time}`;
            let start_timestamp = convert_datetime_to_timestamp(start_time_str);
            let end_timestamp = start_timestamp + 12 * 3600;
            list[i]['start_time'] = start_timestamp;
            list[i]['end_time'] = end_timestamp;
            if (now < end_timestamp && now > start_timestamp) {
                this_round = {
                    "product_type": "this_round",
                    "product": get_product_full_info(list[i])
                };
                break ;
            } else if (now < start_timestamp && now > start_timestamp - 12 * 3600){
                next_round = {
                    "product_type": "next_round",
                    "product": get_product_full_info(list[i])
                };
            }
        }

        console.log('product',this_round ? this_round : next_round)

        return this_round ? this_round : next_round;
    }
  
    function get_product_full_info(item) {
        if (typeof(product_common_info[item['product']]) === 'undefined') {
            return null;
        }
        let common_info = product_common_info[item['product']];
        common_info['compare_price'] = item['variant_price'][0][0].toFixed(2);
        common_info['real_price'] = item['variant_price'][0][1].toFixed(2);
        common_info['start_time'] = item['start_time'];
        common_info['end_time'] = item['end_time'];

        return common_info;
    }

    function show_daily_deal(product) {
        if (is_mobile()) {
            render_mobile(product);
        } else {
            render_pc(product);
        }

        let end_timestamp = product.product.end_time;
        if (product.product_type === 'next_round') {
            end_timestamp = product.product.start_time;
        }
        count_down_run(end_timestamp);
        count_down_timer = setInterval(function() {
            count_down_run(end_timestamp);
        }, 1000);
    }

    
    function render_pc(product) {
        let product_info = product.product;
        let product_type = product.product_type;
        let count_down_str = "Ends in";
        if (product_type == 'next_round') {
            count_down_str = "Starts in";
        }

        let html = "";
        // html += '<div class="bottom_images"><img class="banner_bottom" src="https://cdn.shopify.com/s/files/1/0582/6963/0633/files/91E823CD-5197-47f2-B2A8-6FFB30BC6156.png?v=1688454116" alt="ruko" width="100%" style="margin-top:-30px"></div>';
        html += "<div class='deals-section pc-only'>";
        html +=      "<a href='" + product_info.url + "' class='deals-section-title'>";
        html +=         "<img src='https://cdn.shopify.com/s/files/1/0582/6963/0633/files/lightning.png?v=1687762372' width=26 />";
        html +=         "<h3 class='deals-for-you'><span>Lightning Deals</span></h3>";
        html +=      "<div class='count-down-box'>";
        html +=          "<span class='count-end-in'>" + count_down_str + " </span>";
        html +=          "<div class='count-down-item count-down-hour'>";
        html +=              "<span class='hour-num num-span'>00</span>";
        html +=              "<span class='desc-span'>:</span>";
        html +=          "</div>";
        html +=          "<div class='count-down-item count-down-minute'>";
        html +=              "<span class='minute-num num-span'>00</span>";
        html +=              "<span class='desc-span'>:</span>";
        html +=          "</div>";
        html +=          "<div class='count-down-item count-down-second'>";
        html +=              "<span class='second-num num-span'>00</span>";
        html +=          "</div>";
        html +=         "<img src='https://cdn.shopify.com/s/files/1/0582/6963/0633/files/right.svg?v=1687762445' width=16 />";
        html +=      "</div>";
        html +=      "</a>";
        html +=      "<a style='display:none;' href='" + product_info.url + "' class='deals-img-box'>";
        html +=          "<img src='" + product_info.pc_img + "' alt=''>";
        html +=      "</a>";
        html += "</div>"
        
        if ($('.hdt-sec-slideshow.shopify-section:eq(0)').length > 0) {
            $('.hdt-sec-slideshow.shopify-section:eq(0)').after(html);
        } else {
            $('body').append(html);
        }
    }
    
    function render_mobile(product) {
        let product_info = product.product;
        let product_type = product.product_type;
        let count_down_str = "Ends in";
        if (product_type == 'next_round') {
            count_down_str = "Starts in";
        }
        let discount = (product_info.compare_price - product_info.real_price) / product_info.compare_price * 100;
        discount = discount.toFixed(0);
        discount = discount + "% OFF";
        let html = "";
        // html += '<div class="bottom_images"><img class="banner_bottom2" src="https://cdn.shopifycdn.net/s/files/1/0582/6963/0633/files/1_02_50666b91-c040-4bc3-9a06-5f32f026f33c.webp?v=1701312711" alt="ruko" width="100%" height="auto" style="margin-top:-33px;"></div>';
        html += "<div class='deals-section'>";
        html +=      "<div class='deals-section-title'>";
        html +=          "<h3 class='deals-for-you'><span>Lightning Deals</span></h3>"    
        html +=      "</div>";
        html +=      "<div class='count-down-box'>";
        html +=          "<span class='count-end-in'>" + count_down_str + " </span>";
        html +=          "<div class='count-down-item count-down-hour'>";
        html +=              "<span class='hour-num num-span'>00</span>";
        html +=              "<span class='desc-span'>:</span>";
        html +=          "</div>";
        html +=          "<div class='count-down-item count-down-minute'>";
        html +=              "<span class='minute-num num-span'>00</span>";
        html +=              "<span class='desc-span'>:</span>";
        html +=          "</div>";
        html +=          "<div class='count-down-item count-down-second'>";
        html +=              "<span class='second-num num-span'>00</span>";
        html +=          "</div>";
        html +=      "</div>";
        html +=     "<div class='mobile-img-section'>";
        html +=         "<div class='mobile-big-img'>";
        html +=             "<a href='" + product_info.url + "'><img src='" + product_info.img + "' alt='ruko flash deal'></a>";
        html +=         "</div>";
        html +=         "<div class='mobile-product-title'>" + product_info.name + "</div>";
        html +=         "<div class='mobile-discount-box'>";
        html +=             "<span class='discount-num'>" + discount + "</span>&nbsp;&nbsp;";
        html +=             "<span class='discount-desc'>Limited Time Offer</span>";
        html +=         "</div>";
        html +=         "<div class='mobile-price-box'>";
        html +=             "<span class='mobile-compare-price'>$" + product_info.compare_price + "</span>&nbsp;&nbsp;";
        html +=             "<span class='mobile-real-price'>$" + product_info.real_price + "</span>";
        html +=         "</div>";
        
        html +=     "</div>";
        html += "</div>"
        
        if ($('.hdt-sec-slideshow.shopify-section:eq(0)').length > 0) {
            $('.hdt-sec-slideshow.shopify-section:eq(0)').after(html);
        } else {
            $('body').append(html);
        }
        
        $('.deals-section .mobile-img-section .mobile-img-list li').eq(0).addClass('active-img');
    }
        
    function count_down_run(end_timestamp) {
        let now = set_now_time();
        
        let rest_timestamp = end_timestamp - now;
        if (rest_timestamp < 0) {
            clearInterval(count_down_timer);
            count_down_timer = null;
            location.reload();
            return ;
        }
        
        function pad_zero(num) {
            return num < 10 ? ("0" + num) : num;
        }
        let hour = pad_zero(Math.floor(rest_timestamp / 3600));
        let minute = pad_zero(Math.floor((rest_timestamp % 3600) / 60));
        let second = pad_zero(rest_timestamp % 60);
        
        $('.count-down-box .hour-num').text(hour);
        $('.count-down-box .minute-num').text(minute);
        $('.count-down-box .second-num').text(second);
    }       

    function is_mobile() {
        if ($(window).width() <= 960) {
            return true;
        }
    
        return false;
    }
        
})();